import { Link } from 'react-router';

import { Footer } from '@/components/layout/footer';
import { Logo } from '@/components/layout/logo';

export function NotFoundPage() {
  return (
    <div className="public">
      <div className="public__body" style={{ gridTemplateColumns: '1fr', maxWidth: '36rem' }}>
        <div className="stack">
          <Logo />
          <h1>Whoops!</h1>
          <h2>Something went wrong.</h2>
          <p>
            <Link to="/" className="btn btn--primary">
              Back to home
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
